import moment from 'moment'
import Pack from './pepitePack'

const numberFormatter = new Intl.NumberFormat(global.dataInit.culture, {
  style: 'decimal',
  minimumFractionDigits: 0
})

const priceFormatter = new Intl.NumberFormat(global.dataInit.culture, {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0
})

export default class {
  constructor (model) {
    this.id = model.id
    this.startDay = moment(model.startDay, 'YYYYMMDD')
    this.endDay = this.startDay.clone().add(6, 'days')
    this.week = model.week
    this.year = model.year
    this.nbDisplays = model.nbDisplays
    this.period = model.period
    this.pack = new Pack(model.pack)
    this.isAvailable = model.isAvailable
    this.booker = model.booker
    this.discountRatio = model.discountRatio ?? null
  }

  get formatedWeekNumber () {
    return this.week.padStart(2, '0')
  }

  get formatedNbDisplays () {
    return numberFormatter.format(this.nbDisplays)
  }

  get formatedStartDate () {
    return this.startDay.format('L')
  }

  get formatedEndDate () {
    return this.endDay.format('L')
  }

  get formatedDiscountPrice () {
    if (this.discountRatio !== null) {
      return priceFormatter.format((100 - this.discountRatio) * this.pack.price / 100)
    }
  }

  get formatedBestPrice () {
    if (this.discountRatio !== null) {
      return this.formatedDiscountPrice
    } else {
      return this.pack.formatedPrice
    }
  }
}
